import React from "react";
import { Link } from "react-router-dom";


const Footer = () => {
    const currentYear = new Date().getFullYear();
    return (
        <>
            <footer className="footer-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div
                                className="single-footer-widget"
                            // data-aos="fade-in"
                            // data-aos-duration="1000"
                            // data-aos-delay="100"
                            >
                                <div className="logo">
                                    <Link to="/">
                                        <img
                                            src="/images/white-logo.webp"
                                            alt="white-logo"
                                            style={{
                                                filter: "invert(1) brightness(200%) sepia(100%) saturate(0%)",
                                            }}
                                        />
                                    </Link>
                                    <p>
                                        Ethereal Softech Pvt Ltd, Your top-tier
                                        Mobile and Web App Development Company
                                        in India. We excel in technological
                                        expertise, customizing solutions for
                                        your brand's online dominance.
                                        Innovation meets proficiency, making us
                                        your key to a standout digital identity.
                                        We design and develop your dream.
                                    </p>
                                </div>

                                <ul className="social">
                                    <li>
                                        <Link
                                            to="https://www.linkedin.com/in/ethereal-softech-503399160/"
                                            target="_blank"
                                            aria-label="linkedin"
                                        >
                                            <i className="fab fa-linkedin-in"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="https://www.facebook.com/Ethereal-softech"
                                            target="_blank"
                                            aria-label="facebook"
                                        >
                                            <i className="flaticon-facebook-letter-logo"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="https://twitter.com/EtherealSoftech"
                                            target="_blank"
                                            aria-label="twitter"
                                        >
                                            <i className="flaticon-twitter"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to="https://www.instagram.com/etherealsoftech/"
                                            target="_blank"
                                            aria-label="instagram"
                                        >
                                            <i className="flaticon-instagram-logo"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div
                                className="single-footer-widget"
                            // data-aos="fade-in"
                            // data-aos-duration="1000"
                            // data-aos-delay="200"
                            >
                                <h3>Services</h3>

                                <ul className="footer-services-list">
                                    <li>
                                        <Link to="/services/mobile-app-development">
                                            Mobile App Development
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/web-development">
                                            Web Development
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/cms-ecommerce">
                                            CMS & Ecommerce
                                        </Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/services/sales-force">
                                            Sales Force
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/digital-marketing">
                                            Digital Marketing
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/services/hosting/">
                                            Hosting
                                        </Link>
                                    </li> */}
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div
                                className="single-footer-widget"
                            // data-aos="fade-in"
                            // data-aos-duration="1000"
                            // data-aos-delay="300"
                            >
                                <h3>Quick Links</h3>

                                <ul className="quick-links-list">
                                    <li>
                                        <Link to="/about">About Us</Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/blog">Blog</Link>
                                    </li> */}
                                    <li>
                                        <Link to="/contact">Contact Us</Link>
                                    </li>
                                    <li>
                                        <Link to="/services">Services</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div
                                className="single-footer-widget"
                            // data-aos="fade-in"
                            // data-aos-duration="1000"
                            // data-aos-delay="400"
                            >
                                <h3>Contact</h3>

                                <ul className="footer-contact-list">
                                    <li>
                                        <span className="footer-span">
                                            <i className="fa-solid fa-location-pin"></i>
                                        </span>
                                        408, 4th floor, Jaipur Electronic Market
                                        <br />
                                        Near Riddhi Siddhi Circle, Gopalpura
                                        Bypass Road, Jaipur, Rajasthan-302018
                                        India
                                    </li>
                                    <li>
                                        <span className="footer-span">
                                            <i className="fa-solid fa-location-pin"></i>
                                        </span>
                                        CS-96 , third floor Ansal plaza Vaishali,
                                        <br />
                                        Ghaziabad-201010 India
                                    </li>
                                    <li>
                                        <span className="footer-span">
                                            <i className="fa-solid fa-envelope"></i>
                                        </span>
                                        <Link to="mailto:info@etherealsoftech.com">
                                            info@etherealsoftech.com
                                        </Link>
                                    </li>
                                    <li>
                                        <span className="footer-span">
                                            <i className="fa-solid fa-phone"></i>
                                        </span>
                                        <Link to="tel:8306231041">
                                            +91 8306231041
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="copyright-area">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <p>
                                    &copy;{" 2018-" + currentYear} Ethereal{" "}
                                    Softech Pvt Ltd.All Rights Reserved{" "}
                                </p>
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <ul>
                                    <li>
                                        <Link to="/images/Ethereal_Softech_Pvt.Ltd.pdf" target="_blank" >
                                            <img src="/images/iso.svg" width={"40px"} alt="iso-certificate"/>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/terms-conditions">
                                            Terms & Conditions
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="circle-map">
                    <img
                        src="/images/circle-map.webp"
                        loading="lazy"
                        alt="circle-map"
                    />
                </div>

                <div className="lines">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>
            </footer>
        </>
    );
};

export default Footer;
